export enum TasksTypes {
  GET_TASKS = '@@tasks/GET_TASKS',
  GET_TASKS_SUCCESS = '@@tasks/GET_TASKS_SUCCESS',
  GET_TASKS_FAIL = '@@tasks/GET_TASKS_FAIL',

  GET_TASKS_DETAIL = '@@tasks/GET_TASKS_DETAIL',
  GET_TASKS_DETAIL_SUCCESS = '@@tasks/GET_TASKS_DETAIL_SUCCESS',
  GET_TASKS_DETAIL_FAIL = '@@tasks//GET_TASKS_DETAIL_FAIL',

  ADD_TASKS = '@@tasks/ADD_TASKS',
  ADD_TASKS_SUCCESS = '@@tasks/ADD_TASKS_SUCCESS',
  ADD_TASKS_FAIL = '@@tasks/ADD_TASKS_FAIL',

  DELETE_TASKS = '@@tasks/DELETE_TASKS',
  DELETE_TASKS_SUCCESS = '@@tasks/DELETE_TASKS_SUCCESS',
  DELETE_TASKS_FAIL = '@@tasks/DELETE_TASKS_FAIL',

  UPDATE_TASKS = '@@tasks/UPDATE_TASKS',
  UPDATE_TASKS_SUCCESS = '@@tasks/UPDATE_TASKS_SUCCESS',
  UPDATE_TASKS_FAIL = '@@tasks/UPDATE_TASKS_FAIL',
}
